import dayjs from "dayjs";
import { getInvalidRangeErrorMessage, showToastMessage } from "../../utils/commonFunctions";
import { DeleteIcon, EditIcon, ExportSvg } from "../CommonComponents/svgs/Svgs";
import { TaskCompleteSvg, TaskNotPerformedSvg, TaskOngoingSvg, TaskUpcommingSvg } from "./components/center/modals/Svgs";
import { Command, CustomScheduleFormDataType, CustomScheduleModalDataType, CustomScheduleModalFormType, CustomScheduleModalModeType, ScheduleData, ScheduleMenuOption, ScheduleTask, ScheduleTimeValidator, ScheduleTimeValidatorParams } from "./types";
export const maxScheduleDuration = 1440;
export const START_TIME_REQUIRED_MESSAGE = 'Please enter start time';
const taskTypeDisplayLabelMap: Record<string, string> = {
    Adhoc: 'Ad hoc',
    'customTask': 'Custom Task'
};

export const getTaskTypeDisplayLabel = (type?: string | null) => {
    if (!type) return '';
    return taskTypeDisplayLabelMap[type] ?? type;
}

export const isMissingDateTime = (value: unknown) => {
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === '') || !Number.isFinite(Number(value))
}

export const get_frame_times = (epoch_start_time: number, timeframe_duration: number) => {
    // epoch_start_time = epoch_start_time * 1000;
    const epoch_end_time = epoch_start_time + timeframe_duration;
    const epoch_center_time = ((epoch_start_time! + epoch_end_time) / 2);

    const start_time = {
        date: `${get_formated_time(epoch_start_time)?.split('T')?.[0]}T`,
        time: `${get_formated_time(epoch_start_time!)?.split('T')?.[1]}`,
        epoch: epoch_start_time!
    }
    const end_time = {
        date: `${get_formated_time(epoch_end_time)?.split('T')?.[0]}T`,
        time: `${get_formated_time(epoch_end_time)!.split('T')?.[1]}`,
        epoch: epoch_end_time!
    }
    const center_time = {
        date: `${get_formated_time(epoch_center_time)?.split('T')?.[0]}T`,
        time: `${get_formated_time(epoch_center_time)!.split('T')?.[1]}`,
        epoch: epoch_center_time!
    }
    const time_list: { date: string, time: string, epoch: number }[] = [start_time, center_time, end_time];
    return time_list;
}

export const get_formated_time = (time: number) => {
    const date = new Date(time * 1000);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day}T ${hours}:${minutes}:${seconds}Z`;
}

export function calculate_duration(start: number, end: number) {
    // Calculate the difference in seconds
    const durationInSeconds = end - start;

    // Calculate minutes and seconds
    const minutes = Math.floor(durationInSeconds / 60);
    const seconds = durationInSeconds % 60;

    // Format the result as "Xm Ys"
    return `${minutes}m ${seconds}s`;
}

export const get_task_status_icon = (start_time: number, end_time: number, current_time: number) => {
    if (start_time <= current_time && end_time >= current_time) {
        return <TaskOngoingSvg />
    } else if (current_time < start_time) {
        return <TaskUpcommingSvg />
    } else if (current_time > end_time) {
        return <TaskCompleteSvg />
    } else {
        return <TaskNotPerformedSvg />
    }
}

export const get_time_only = (time: number) => {
    const timestamp = new Date(time).toUTCString();
    const match = timestamp.match(/\b\d{2}:\d{2}:\d{2}\b/); // Look for the time in HH:MM:SS format
    if (match) {
        return match[0];
    } else {
        return '00:00:00';
    }
}


export const getContactCurrentStatus = (currentTime: number, start_time: number, end_time: number, not_booked?: boolean) => {
    if (not_booked) {
        return 'not_booked';
    } else if (currentTime >= start_time && currentTime <= end_time) {
        return 'ongoing'
    } else if (currentTime < start_time) {
        return 'upcoming'
    } else if (currentTime > end_time) {
        return 'completed'
    } else {
        return 'not_scheduled'
    }
}

export const ScheduleMenuList = [
    {
        name: 'Edit',
        Icon: <EditIcon />
    },
    {
        name: 'Export',
        Icon: <ExportSvg />
    },
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
]

export const MenuList = [
    {
        name: 'Edit',
        Icon: <EditIcon />
    },
    {
        name: 'Delete',
        Icon: <DeleteIcon />
    },
]

const getCommandDelay = (command: Command | null, selectedTask: ScheduleTask | null, type: string) => {
    if (!command || !selectedTask) return 0;
    if (type === 'update-telecommand') {
        const commandsList = selectedTask.commandsList || [];
        const index = commandsList.findIndex((c) => c.commandId === command.commandId);
        if (index <= 0) {
            return Math.round(command.epoch - selectedTask.startTime);
        }
        const prev = commandsList[index - 1];
        return Math.round(command.epoch - (prev.epoch));
    }
    return 10;
}

export const getUpdateCustomScheduleModalData = (mode: CustomScheduleModalModeType, selectedSchedule: ScheduleData, selectedTask: ScheduleTask | null, command: Command | null, type: string, scheduleType: ScheduleMenuOption) => {
    const rawDelay = getCommandDelay(command, selectedTask, type);
    const clampedDelay = Math.max(0, rawDelay);
    // commandRefTime satisfies: commandRefTime + clampedDelay = command.epoch
    // This prevents the useEffect in TelecommandForm from overriding the start time
    const commandRefTime = type === 'update-telecommand' && command != null
        ? (command.epoch - clampedDelay)
        : null;

    return {
        mode: mode,
        name: selectedSchedule?.scheduleName as string,
        scheduleType: scheduleType,
        startTime: selectedSchedule?.startTimeISO8601 as string,
        duration: String(selectedSchedule?.duration),
        formType: type as CustomScheduleModalFormType,
        formData: {
            source: "taskPlan" as CustomScheduleFormDataType['source'],
            sourceId: '',
            startTime: selectedTask?.startTime || null,
            duration: selectedTask?.duration || '',
            taskData: getInitialFormTaskData('Generate'),
            telecommandData: type !== 'add-telecommand' ? {
                type: command?.type || '',
                name: command?.name || '',
                time: command?.epoch ?? null,
                component: command?.subsystem || 'All',
                sequenceData: command?.telecommandDetails?.telecommand || null,
                duration: command?.duration || '',
                delay: clampedDelay,
                timeOption: 'startTime',
                commandStartTime: commandRefTime,
                commandEndTime: commandRefTime,
                taskId: selectedTask?.taskId || '',
                commandId: command?.commandId || ''
            } : {
                type: "Bus",
                name: "",
                time: command ? command?.epoch + command?.duration + 10 : null,
                component: "All",
                sequenceData: null,
                duration: 2,
                delay: command ? 10 : 0,
                timeOption: 'startTime',
                commandStartTime: command ? command?.epoch : null,
                commandEndTime: command ? command?.epoch + command?.duration : null,
                taskId: selectedTask?.taskId || '',
                commandId: command?.commandId || ''
            }
        },
        scheduledTasks: selectedSchedule?.scheduledTasks || [],
        selectedSchedule: selectedSchedule,
        selectedTelecommand: command || null,
        selectedTask: selectedTask || null,
        loading: false,
        formLoading: false,
        scheduleGenerated: false,
        recentlyEditedTelecommand: null
    }
}

export const getInitialFormTelecommandData = () => ({
    type: "Bus",
    name: "",
    time: null,
    component: "All",
    sequenceData: null,
    duration: 2,
    delay: 0,
    timeOption: 'startTime',
    commandStartTime: null,
    commandEndTime: null,
    taskId: '',
    commandId: ''
})
export const getInitialFormTaskData = (menu?: ScheduleMenuOption) => ({
    taskName: '',
    adhocTaskId: '',
    taskSource: 'adhocTask',
    time: menu === 'Build' ? dayjs().utc().unix() : null,
    delay: menu === 'Build' ? 0 : 10,
    timeOption: 'startTime',
    taskStartTime: null,
    taskEndTime: null
})
export const getInitialCustomScheduleFormData = (menu: ScheduleMenuOption) => ({
    mode: 'create' as CustomScheduleModalModeType,
    name: '',
    scheduleType: menu,
    startTime: null,
    duration: null,
    formType: menu === 'Build' ? 'add-task' : 'schedule' as CustomScheduleModalFormType,
    formData: {
        source: "taskPlan",
        sourceId: '',
        startTime: dayjs().utc().unix(),
        duration: 180,
        taskData: getInitialFormTaskData(menu),
        telecommandData: getInitialFormTelecommandData()
    },
    scheduledTasks: [],
    selectedSchedule: null,
    selectedTelecommand: null,
    selectedTask: null,
    loading: false,
    formLoading: false,
    scheduleGenerated: false,
    recentlyEditedTelecommand: null,
})

export const validateCustomScheduleFormData = (formType: CustomScheduleModalFormType, scheduleType: ScheduleMenuOption | undefined, data: CustomScheduleFormDataType | undefined, isFirstTask: boolean, isFirstCommandSelected: boolean) => {
    if (!data || !formType || !scheduleType) return false
    const scheduleDurationInSecs = maxScheduleDuration * 60;
    const taskData = data?.taskData
    const taskSource = taskData?.taskSource
    const isTaskForm = ['add-task'].includes(formType)
    const isCommandForm = ['add-telecommand', 'update-telecommand'].includes(formType)
    if (formType === 'schedule' && !data?.sourceId) {
        const source = data?.source
        const sourceType = source === 'taskPlan' ? 'Task Plan' : 'Ad hoc Task'
        showToastMessage('info', `Please select ${sourceType}`)
        return false
    }
    else if (formType === 'schedule' && isMissingDateTime(data?.startTime)) {
        showToastMessage('info', START_TIME_REQUIRED_MESSAGE)
        return false
    }
    else if (formType === 'schedule' && data?.source === 'taskPlan' && (!data?.duration || Number(data?.duration) < 1)) {
        showToastMessage('info', getInvalidRangeErrorMessage('Duration', 1, maxScheduleDuration, 'mins'))
        return false
    }
    else if (isTaskForm && taskSource === 'adhocTask' && !taskData?.adhocTaskId) {
        showToastMessage('info', 'Please select Task')
        return false
    }
    else if (isTaskForm && taskSource === 'customTask' && !taskData?.taskName) {
        showToastMessage('info', 'Please enter Task Name')
        return false
    }
    else if (isTaskForm && isMissingDateTime(taskData?.time)) {
        showToastMessage('info', START_TIME_REQUIRED_MESSAGE)
        return false
    }
    else if (isTaskForm && !isFirstTask) {
        const taskDelayVal = Number(taskData?.delay);
        const taskTimeOption = taskData?.timeOption;
        const minAllowedTaskDelay = taskTimeOption === 'endTime' ? 0 : 1;
        if (isNaN(taskDelayVal) || taskDelayVal < minAllowedTaskDelay) {
            showToastMessage('info', minAllowedTaskDelay === 0 ? getInvalidRangeErrorMessage('Delay', 0, scheduleDurationInSecs, 'secs') : getInvalidRangeErrorMessage('Delay', 1, scheduleDurationInSecs, 'secs'))
            return false
        }
    }
    else if (isCommandForm && !data?.telecommandData?.component) {
        showToastMessage('info', 'Please select Component')
        return false
    }
    else if (isCommandForm && !data?.telecommandData?.name) {
        showToastMessage('info', 'Please select Command')
        return false
    }
    else if (isCommandForm && formType !== 'update-telecommand' && !isFirstCommandSelected && (data?.telecommandData?.delay === '' || data?.telecommandData?.delay === null || data?.telecommandData?.delay === undefined)) {
        showToastMessage('info', 'Delay is required')
        return false
    }
    else if (isCommandForm && formType !== 'update-telecommand' && !isFirstCommandSelected) {
        const delayVal = Number(data?.telecommandData?.delay);
        const timeOption = data?.telecommandData?.timeOption;
        // Allow 0 delay when timeOption is 'endTime', otherwise require >= 1
        const minAllowed = timeOption === 'endTime' ? 0 : 1;
        if (isNaN(delayVal) || delayVal < minAllowed) {
            showToastMessage('info', minAllowed === 0 ? 'Delay should be greater than or equal to 0 sec' : 'Delay should be greater than 1 sec')
            return false
        }
    }
    else if (isCommandForm && (!data?.telecommandData?.duration || Number(data?.telecommandData?.duration) < 1)) {
        const duration = data?.telecommandData?.duration;

        if (duration === null || duration === undefined || duration === '') {
            showToastMessage('info', 'Duration is required');
        } else if (Number(duration) <= 1) {
            showToastMessage('info', 'Duration should be greater than 1 sec');
        }
        return false
    }
    else if (isCommandForm && isMissingDateTime(data?.telecommandData?.time)) {
        showToastMessage('info', START_TIME_REQUIRED_MESSAGE)
        return false
    }
    return true
}

export const validateCustomScheduleData = (data: ScheduleData) => {
    if (!data) return false
    else if (!data?.scheduleName) {
        showToastMessage('info', 'Please enter a Schedule Name')
        return false
    }
    else if (!data?.scheduledTasks || data?.scheduledTasks?.length === 0) {
        showToastMessage('info', 'Please add at least one task')
        return false
    }
    return true
}

export const validateSelectedCommandData = (selectedSchedule: ScheduleData | null, selectedTask: ScheduleTask | null, command: Command | null, data: { name: string, scheduleId: string, taskId?: string, commandId?: string }) => {
    if (!selectedSchedule || selectedSchedule?.scheduleId !== data?.scheduleId) {
        showToastMessage('error', 'Schedule not found')
        return false
    }
    else if (!selectedTask || selectedTask?.taskId !== data?.taskId) {
        showToastMessage('error', 'Task not found')
        return false
    }
    else if (!command || command?.commandId !== data?.commandId) {
        showToastMessage('error', 'Command not found')
        return false
    }
    return true
}

export const calculateTimeBasedOnTimeOption = ({
    timeOption,
    startTime,
    endTime,
    value = 0,
    fallbackTime = 0
}) => {
    const baseTime =
        timeOption === 'startTime'
            ? (startTime ?? fallbackTime)
            : (endTime ?? fallbackTime);
    return Number(baseTime) + Number(value ?? 0);
};

export const createScheduleTimeValidator = (): ScheduleTimeValidator => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let lastWarning: string | null = null;

    const validate = (({
        scheduleTime,
        scheduleType = 'schedule',
        initialStartTime = null,
        initialCurrentTime = null,
        delay = 500
    }: ScheduleTimeValidatorParams) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            const warning = getScheduleTimeWarning(
                scheduleTime,
                scheduleType,
                initialStartTime,
                initialCurrentTime
            );

            if (!warning) {
                lastWarning = null;
                return;
            }

                showToastMessage('info', warning);
                lastWarning = warning;
        }, delay);
    }) as ScheduleTimeValidator;

    validate.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
            lastWarning = null;
        }
    };

    validate.reset = () => {
        lastWarning = null;
    };

    return validate;
};

export const getScheduleTimeWarning = (
    scheduleTime: number | null | undefined,
    scheduleType: string,
    initialStartTime: number | null | undefined = null,
    initialCurrentTime: number | null | undefined = null
): string | null => {
    if (scheduleTime === null || scheduleTime === undefined) {
        return null;
    }

    // Use the preserved initial current time, not the continuously changing Date.now()
    const referenceTime = initialCurrentTime !== null ? initialCurrentTime : Math.floor(Date.now() / 1000);
    const sevenDaysInSeconds = 7 * 24 * 60 * 60;


    const scheduleLabel =
        scheduleType === 'Generate'
            ? 'schedule to be generated'
            : scheduleType === 'Build'
                ? 'schedule to be built'
                : 'schedule';

    if (scheduleTime < referenceTime) {
        return `The ${scheduleLabel} is in the past`;
    }

    if (scheduleTime > referenceTime + sevenDaysInSeconds) {
        return `The ${scheduleLabel} is beyond the recommended scheduling window`;
    }

    return null;
};
